module.exports = __webpack_public_path__ + "static/media/21+img.cd4df577.png";